<style>
    body {
        font-family: Arial, sans-serif;
        margin: 20px;
        line-height: 1.6;
    }
    h2 {
        font-weight: bold;
        margin-top: 20px;
    }
    p {
        margin: 10px 0;
    }
    a {
        color: blue;
        text-decoration: none;
    }
</style>
<div class="head" style="display: flex; align-items: center;">
    <img src="assets/images/mobilize-logo-small.png" alt="logo" width="150px">
    <a href="javascript: window.close()" class="mobilize-btn btn-orange">inchide</a>
</div>
<div class="static-page-wrapper">
    <img src="assets/images/logo.png">
    <div class="static-page-title">Date de contact</div>

    <div class="static-page-content">
        <h2>RCI LEASING ROMANIA IFN SA</h2>
        <p>București, str. Preciziei, nr. 3G, Clădirea A et.6, camera AE6 20, sector 6, cod postal 062202</p>
        <p>J2002000096407, CUI RO14378619, nr. de înregistrare în Registrul General al BNR RG-PJR-41-110108 şi în Registrul Special al BNR RS-PJR-41-110016</p>
        <p>Tel. 021.201.2000</p>
        <p>E-mail: <a href="mailto:rcileasing.romania@mobilize-fs.com">rcileasing.romania&amp;mobilize-fs.com</a></p>

        <h2>RCI FINANŢARE ROMÂNIA SRL</h2>
        <p>București, str. Preciziei, nr. 3G, Clădirea A et.6, camera AE6 24, sector 6, cod postal 062202</p>
        <p>J2000010673407, CUI RO13542496</p>
        <p>Tel. 021.201.2000</p>
        <p>E-mail: <a href="mailto:rcileasing.romania@mobilize-fs.com">rcileasing.romania&amp;mobilize-fs.com</a></p>

        <h2>RCI BROKER DE ASIGURARE</h2>
        <p>București, str. Preciziei, nr. 3G, Clădirea A et.6, camera AE6 21 și AE6 22, sector 6, cod postal 062202</p>
        <p>J2005014872407, CUI 17907641, Autorizație de funcționare nr. 3966/23.11.2005 emisă de Comisia de Supraveghere a Asigurărilor, numărul de înmatriculare în Registrul brokerilor de asigurare: RBK-326/24.11.2005</p>
        <p>Telefon: 021.201.2000</p>
        <p>E-mail: <a href="mailto:rcibroker.romania@mobilize-fs.com">rcibroker.romania&amp;mobilize-fs.com</a></p>

        <h2>Program</h2>
        <p>Luni-Vineri, 9.00-18.00</p>

        <p><em>*versiune 11.03.2026</em></p>
    </div>
</div>
